import { FAQ_TOPICS } from "../../gql/StaticPagesQueris";
import FaqSearch from "../FAQSearchField";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

export default {
  name: "faq",

  data() {
    return {
      faqTopics: [],
      typeTopics: "user"
    };
  },

  apollo: {
    faqTopics: {
      query: FAQ_TOPICS
    }
  },

  mounted: function() {
    if (this.$route.params && this.$route.params.type) {
      this.typeTopics = this.$route.params.type;
    }
  },

  computed: {
    sortedFaqTopics() {
      if (this.faqTopics.length > 0) {
        return this.faqTopics.find(t => t.type === this.typeTopics);
      } else {
        return [];
      }
    }
  },

  methods: {
    activatedTab(type) {
      this.typeTopics = type;
    }
  },

  components: {
    LoadingIcon,
    FaqSearch
  }
};
